export default __webpack_public_path__ + "static/media/persona.103965e7.png";